import React, {useEffect, useState} from "react";
import {RiArrowDownSFill, RiArrowUpSFill} from "react-icons/ri";
import neverLandUtils from "../../utils/NeverLandUtils";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_RATE_DATA_API} from "../../constants/api_constants";
import {getImage} from "../../constants/constants";

const RateComponent = ({dataId, analysisType}) => {
  const [buttonValue, setButtonValue] = useState({name: "승무패", value: 1});  // -1. 임시 (미구현), 0. 임시 (가짜값), 1. 승무패, 2. 핸디탭, 3. U/O, 4. SUM
  const [domesticRate, setDomesticRate] = useState([]);
  const [foreignRate, setForeignRate] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  const buttonList = [
    {name: "승무패", value: 1},
    {name: "핸디캡", value: 2},
    {name: "U/O", value: 3},
    {name: "SUM", value: 4},
  ]

  useEffect(() => {
    getRateData();
  }, [buttonValue]);

  const getRateData = () => {
    // 최근 전적
    getFetcherAnalysis().get(GET_RATE_DATA_API + `?dataId=${dataId}&allotType=${buttonValue.value}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data[0].rateTableData[0].length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            setDomesticRate(data[0]?.rateTableData[0].domesticRate || []);
            setForeignRate(data[0]?.rateTableData[0].foreignRate || []);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }


  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  return (
      <div className="flx flex-col justify-center px-3 min-h-[calc(100vh-8rem)] pt-5">

        {/* 버튼 영역 */}
        <div className="w-full flex flex-row border border-gray-500 justify-around px-3 py-2 rounded-lg shadow-md mt-5">
          {buttonList.map((button) => {
            return (
                <button
                    className={neverLandUtils.classNames(buttonValue.value === button.value ? "bg-gray-900 text-white rounded-lg py-0.5" : "", "px-3")}
                    onClick={() => setButtonValue(button)}
                >
                  {button.name}
                </button>
            )
          })}
        </div>


        <div className="mt-7 mb-10">
          <span className="text-xl font-bold">국내배당</span>
          <_rateTable buttonValue={buttonValue} list={domesticRate}/>
        </div>

        <div>
          <span className="text-xl font-bold">해외배당</span>
          <span className="text-xl font-bold text-gray-400"> - 준비중입니다.</span>
          {/*<_rateTable buttonValue={buttonValue} list={foreignRate}/>*/}
        </div>
      </div>
  )
}
export default RateComponent;


export const _rateTable = ({buttonValue, list}) => {
  const handleChangedRate = (changeRate) => {
    let _changeRate = Number(changeRate);
    if (_changeRate === 0) return;
    if (_changeRate > 0)
      return (<RiArrowUpSFill aria-hidden="true" className="h-5 w-auto text-red-600"/>);
    if (_changeRate < 0)
      return (<RiArrowDownSFill aria-hidden="true" className="h-5 w-auto text-blue-600"/>);
    return null;
  }

  return (
      <table className="w-full border border-gray-900 text-sm mt-2 shadow-lg">
        <thead className="text-center bg-gray-900 text-white">
        <tr>
          {(buttonValue.name === "핸디캡" || buttonValue.name === "U/O") && <th className="w-1/7">{buttonValue.name}</th>}
          <th className="w-1/7">승</th>
          <th className="w-1/7">무</th>
          <th className="w-1/7">패</th>
          <th className="w-2/7 whitespace-nowrap">변동시각</th>
        </tr>
        </thead>

        <tbody className="divide-y divide-stone-400 text-center">
        {list.length === 1 && (
            <tr className="h-4">
              {(buttonValue.name === "핸디캡" || buttonValue.name === "U/O") && <td>-</td>}
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td><p>변동없음</p></td>
            </tr>
        )}
        {list?.map((data, index) => (
            <tr key={index} className="h-4">
              {(buttonValue.name === "핸디캡" || buttonValue.name === "U/O") &&
                  <td>
                    <div className="flex flex-row items-center justify-center space-x-1">
                      <span>{data.extra}</span>
                    </div>
                  </td>
              }
              <td>
                <div className="flex flex-row items-center justify-center space-x-1">
                  <span>{data.win}</span>
                  {handleChangedRate(data.changedWinValue)}
                </div>
              </td>
              <td>
                <div className="flex flex-row items-center justify-center space-x-1">
                  <span>{data.draw <= 1 ? "-" : data.draw}</span>
                  {handleChangedRate(data.changedDrawValue)}
                </div>
              </td>
              <td>
                <div className="flex flex-row items-center justify-center space-x-1">
                  <span>{data.lose}</span>
                  {handleChangedRate(data.changedLoseValue)}
                </div>
              </td>
              <td>
                {data.changeDate && (
                    <div className="flex flex-col items-center justify-center space-x-1 whitespace-nowrap">
                      {/* 날짜 */}
                      <div>{data.changeDate.split(" ")[0]}</div>
                      {/* 시간 */}
                      <div>{data.changeDate.split(" ")[1]}</div>
                    </div>
                )}
              </td>
            </tr>
        ))}
        </tbody>
      </table>
  )
}